import { render, staticRenderFns } from "./Google.vue?vue&type=template&id=898c290a&scoped=true&"
import script from "./Google.vue?vue&type=script&lang=js&"
export * from "./Google.vue?vue&type=script&lang=js&"
import style0 from "./Google.vue?vue&type=style&index=0&id=898c290a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898c290a",
  null
  
)

export default component.exports